import SlideshowButtonSdk from '../components/Slideshow/SlideshowButton/corvid/SlideshowButton.corvid';


const SlideshowButton = {
  sdk: SlideshowButtonSdk
};


export const components = {
  ['SlideshowButton']: SlideshowButton
};

